/** Keep the same key for a retry of the same action and exact payload. */
export function providerCommandKeys(createId: () => string = () => crypto.randomUUID()) {
  const keys = new Map<string, string>();
  return (action: string, payload: unknown): string => {
    const fingerprint = JSON.stringify([action, payload]);
    const existing = keys.get(fingerprint);
    if (existing) return existing;
    const key = createId();
    keys.set(fingerprint, key);
    return key;
  };
}

/** An omitted website leaves the saved value unchanged; null explicitly clears it. */
export function locationUpdateFields<T extends { website?: string }>(fields: T) {
  return { ...fields, website: fields.website || null };
}

export function campaignDates(start: string, end: string) {
  const startsAt = new Date(start);
  const expiresAt = new Date(end);
  if (!Number.isFinite(startsAt.getTime()) || !Number.isFinite(expiresAt.getTime()) || expiresAt <= startsAt) {
    throw new Error('Choose a valid start and a later end.');
  }
  return { startsAt: startsAt.toISOString(), expiresAt: expiresAt.toISOString() };
}
